let settings = {};

switch (process.env.VUE_APP_ENV){
  case 'production':
    settings = {
      solrUri: "https://solrgardens2.benoitcollienne.com:443/solr/solr-prod-apps/select?",
      drupalApiUri: "https://gardens.brussels/"
    }
    break;
  case 'staging':
    settings = {
      solrUri: "https://solrgardens2.benoitcollienne.com:443/solr/solr-stage-apps/select?",
      drupalApiUri: "https://gardens.benoitcollienne.com/"
    }
    break;
    case 'production_be':
      settings = {
        solrUri: "https://solrgardens2.benoitcollienne.com:443/solr/solr-prod-apps/select?",
        drupalApiUri: "https://prdgardens.gardens.brussels/"
      }
      break;
    case 'staging_be':
      settings = {
        solrUri: "https://solrgardens2.benoitcollienne.com:443/solr/solr-stage-apps/select?",
        drupalApiUri: "https://uat.gardens.brussels/"
      }
      break;
  case 'development':
    settings = {
      solrUri: "https://gardens.ddev.site:8984/solr/gardens_dev/select?",
      drupalApiUri: "https://gardens.ddev.site/"
    }
    break;
}

const appSettings = settings;

export {
  appSettings
}
